import { render, staticRenderFns } from "./_Comments.vue?vue&type=template&id=6b36430a&scoped=true&"
import script from "./_Comments.vue?vue&type=script&lang=js&"
export * from "./_Comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36430a",
  null
  
)

export default component.exports